export const PRODUCTION_EQUIPMENT_CATEGORIES = [
    'Sound',
    'Staging',
    'Visuals',
    'DJ Equipment',
    'Lighting',
    'Special Effects',
    'Other',
];

const categoryLookup = PRODUCTION_EQUIPMENT_CATEGORIES.reduce((lookup, category) => {
    lookup[category.toLowerCase()] = category;
    return lookup;
}, {});

export const getProductionEquipmentCategory = product => {
    const productCategories = Array.isArray(product?.categories) ? product.categories : [];

    for (const categoryPath of productCategories) {
        const rootCategory = String(categoryPath || '').split('/')[0].trim().toLowerCase();
        if (categoryLookup[rootCategory] && categoryLookup[rootCategory] !== 'Other') {
            return categoryLookup[rootCategory];
        }
    }

    return 'Other';
};

export const getProductionBuilderCategory = builder => (
    String(builder?.type || '').split('//')[0] === 'wall' ? 'Visuals' : 'Staging'
);
